import React from 'react';

function AboutUs() {
  return (
    <div>
<main className="main">
  {/* Page Title */}
  <div className="page-title" data-aos="fade" style={{backgroundImage: 'url(assets/img/about-page-title-bg.jpg)'}}>
    <div className="container">
      <h1>Our Services</h1>
    </div>
  </div>{/* End Page Title */}
  <div className="main">
    <div className='img-cycle'>
      <img src="assets/img/services/Cycle.webp" alt />
    </div>
    <div className="Billing-Process">
      <h1>How Our Billing Process Works?</h1>
    </div>
  </div>
  {/* Services */}
  <section id="why-us" className="why-us section">
    <div id="revenue-cycle-management" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Revenue Cycle Management-01.jpg" alt />
        </div>
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Revenue Cycle Management</h3>
                  <h4 className="mb-3">RCM makes sure healthcare professionals get paid what they are entitled to. </h4>
                  <p>This entire financial process—from patient registration and appointment scheduling to the last payment of balances—is facilitated by medical billing software. Accurately  identify collect and manage.For the physician's medical center to have better financial results, our RCM billing company improves the revenue cycle.
                  the statement care Medical Revenue Service is the answer to all of your financial problems with your practice. Give us a call to see how we can streamline a provider's whole revenue cycle process to increase income while satisfying patients.</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
  </section>{/* /Services */}
  {/* Services */}
  <section id="why-us" className="why-us section">
    <div id="medical-billing" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Medical Billing</h3>
                  <h4 className="mb-3">Medical Billing Reporting and Analysis is very crucial in medical billing. Analysis of the reported data helps appraise</h4>
                  <p>Practice’s execution and financial of particular healthcare organization. Reporting and analysis take account of claims; both approved and denied, and assess the strength of the relation with insurance companies.<br/>
                  Your Monthly Business Analysis Report provides you with a concise, easy-to-read overview of your practice's performance. Your study will comprise, among other things, treatment billing analysis, insurance and patient account aging reports, and financial information for your practice. A range of information is also offered to help with your marketing and advertising requirements. You can request certain facts to be included in you.</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
          <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Medical Billing-01.png" alt />
        </div>
        </div>
      </div>
  </section>{/* /Services */}
    {/* Services */}
    <section id="why-us" className="why-us section">
    <div id="denial-management" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Denial Management-01.png" alt />
        </div>
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Denial Management</h3>
                  <h4 className="mb-3">Common reasons for rejected or denied claims include coding errors, duplicate claims, lack of medical necessity, patient eligibility issues, and insufficient documentation. </h4>
                  <p>The statement care
                    Investigate the reason for every denied claim
                    Focus on to fix the issue

                    appeal to the insurance company

                    We are aware that every denial case is unique
                    In order to properly follow up with patients, we rectify invalid or erroneous medical codes, offer supporting clinical data, challenge any previous authorization denials, and comprehend any legitimate denial situations. Before resubmitting, we validate all clinical data once more.</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
  </section>{/* /Services */}
  {/* Services */}
  <section id="why-us" className="why-us section">
    <div id="patient-experience-managemen" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Patient Experience Management</h3>
                  <h4 className="mb-3">Having the statement care as your partner for billing and credentialing needs, means efficiency and accuracy. </h4>
                  <p>We at the statement care pride ourselves on our meticulous attention to detail, which in return reduces inaccuracies and errors. 
                  Ensuring timely reimbursements for our clients. 

                   Employees. 
                  Our employees bring years of experience in billing and credentialing.  Well- versed in the latest industry standards and practices. 

                  Personalized service : 
                  The statement care offers tailored solutions to meet your requirements and needs, as we understand each healthcare provider is unique. 
                  This guarantees that our clients receive the best service possible.</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
          <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/why-us-bg.png" alt />
        </div>
        </div>
      </div>
  </section>{/* /Services */}
    {/* Services */}
    <section id="why-us" className="why-us section">
    <div id="practice-management" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Practice Management-01.jpg" alt />
        </div>
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Practice Management</h3>
                  <h4 className="mb-3">The Medical Practice Management Software’s billing feature enables the practice personnel to create accurate invoices for the services rendered and also automated billing processes with accurate allocation of billing codes.</h4>
                  <p><ul className='services-ul-li'>
                    <li>concentration on patient.  <br/> Through the coordination and management of medical practices, the practice management system frees up doctors to concentrate on quality rather than administrative tasks. Insurance billing challenges and patient management are handled because scheduling and tracking are automated. When employees are not pressed for time at work, they can spend more time with the patient.
                      </li>
                    <li>Boosts Productivity, Profitability, and Efficiency.<br/> The practice management system automates standard functions. For example, it sends appointment reminders and maintains inventory records. It places extra orders when stock is low. Hospitals and medical staff don't give a damn about the patient's past or medical records. It increases productivity as a result.
                      </li>
                    <li>Cuts Down on Errors.<br/> Using a practice management system lowers errors compared to handwritten notes. Paperless record keeping has taken precedence because to the use of tablets and cellphones for documentation. The practice management system can also be used to manage papers.
                      </li>
                      </ul></p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
  </section>{/* /Services */}
  {/* Services */}
  <section id="why-us" className="why-us section">
    <div id="medical-coding" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Medical Coding</h3>
                  <h4 className="mb-3">the statement care come up with Medical coding services in Arkansas and near by state</h4>
                  <p>Medical coding is the variationof narrative descriptions of diseases, injuries, and healthcare procedures into numeral or alphameric nomination(that is, code numbers). code number narrate the patient diagnoses.codes were established to sort out  all reason for healthcare visit


                  If your practice is pursue to review, audit or update your medical coding practices then we welcome your inquiries.The statement care can take care of your medical coding needs!</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
          <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/medical-coding-services.webp" alt />
        </div>
        </div>
      </div>
  </section>{/* /Services */}
    {/* Services */}
    <section id="why-us" className="why-us section">
    <div id="analytics-reporting" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Analytics & Reporting-01.png" alt />
        </div>
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Analytics & Reporting</h3>
                  <h4 className="mb-3">Medical Billing Reporting and Analysis is very crucial in medical billing. Analysis of the reported data helps appraise. </h4>
                  <p>practice’s execution and financial of particular healthcare organization. Reporting and analysis take account of claims; both approved and denied, and assess the strength of the relation with insurance companies.<br/>

                  Your Monthly Business Analysis Report provides you with a concise, easy-to-read overview of your practice's performance. Your study will comprise, among other things, treatment billing analysis, insurance and patient account aging reports, and financial information for your practice. A range of information is also offered to help with your marketing and advertising requirements. You can request certain facts to be included in you…</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
  </section>{/* /Services */}
  {/* Services */}
  <section id="why-us" className="why-us section">
    <div id="eligibility-management" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Eligibility Management</h3>
                  <h4 className="mb-3">Welcome to The statement care </h4>
                  <p>You can rely on us to improve and simplify your business.Our commitment is to verify patients' insurance coverage accurately, reducing the number of claim denials and increasing income since we value accuracy.Simplified eligibility manages all kinds of verification requirements and provides the information needed to accurately file claims and get payment on schedule. 
                  Statement Care confirms the eligibility and identity of patients in order to guarantee correct and secure handling of their information.
                  Our knowledgeable and kind staff is dedicated to provide top-notch assistance and care.We are happy to answer your questions.</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
          <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Eligibility Management-01.png" alt />
        </div>
        </div>
      </div>
  </section>{/* /Services */}
    {/* Services */}
    <section id="why-us" className="why-us section">
    <div id="credentialing" className="container section-title" data-aos="fade-up">
      <h2></h2>
    </div>
    <div className="container">
      <div className="row g-0">
        <div className="col-xl-5 img-bg" data-aos="fade-up" data-aos-delay={100}>
          <img src="assets/img/services/Credentialing-01.png" alt />
        </div>
        <div className="col-xl-7 slides position-relative" data-aos="fade-up" data-aos-delay={200}>
          <div className="swiper">
            <div className="swiper-wrapper">
                <div className="item">
                  <h3 className="mb-3">Credentialing</h3>
                  <h4 className="mb-3">Executive Medical Credentialing Services in ARKANSAS,AR. </h4>
                  <p>The statement care is a primary Medical Credentialing Service Provider
                      Healthcare Insurance Credentialing Solution
                      We can register the practice and providers with a National Provider Identifier (NPI), create a CAQH provider number, enroll you for Electronic Funds Transfer (EFT) and Electronic Remittance Advice (ERA), and handle your credentialing applications with the insurance companies of your choice, increasing insurance remunerat.
                      credentialing is a complex process that involves a lot of validation and verification at different stages by the insurance network. This means a single mistake can result in denials and wastage of resources such as time and money.

                      in statement care we  offers the best healthcare credentialing solutions.</p>
                </div>
              </div>{/* End slide item */}
            </div>
            <div className="swiper-pagination" />
          </div>
        </div>
      </div>
  </section>{/* /Services */}

    {/* Call To Action Section */}
    <section id="call-to-action" className="call-to-action section">
    <img src="assets/img/drcall.jpeg" alt />
    <div className="container">
      <div className="row justify-content-center" data-aos="zoom-in" data-aos-delay={100}>
        <div className="col-xl-10">
          <div className="text-center">
            <h3>Call To Action</h3>
            <p>Call us 24/7 </p>
            <a className="cta-btn" href="#">+1 (917) 690-2742</a>
          </div>
        </div>
      </div>
    </div>
  </section>{/* /Call To Action Section */}

</main>
    </div>
  );
}

export default AboutUs;
